function Kbocombo() {
    return <></>;
}

export default Kbocombo;
